import _ from "lodash";
import {getStepAnswer, setQuestionAnswerFromStore} from "../utils";

export const DEFAULT_UNSAVED_CHANGES_DIALOG = {
  title: "Ungespeicherte Änderungen",
  message: "Sie haben Änderungen vorgenommen, die noch nicht gespeichert wurden. Wenn Sie ohne Speichern fortfahren, " +
    "werden diese Änderungen verworfen und können nicht wiederhergestellt werden.",
  confirmButtonText: "Ohne Speichern fortfahren",
  rejectButtonText: "Abbrechen",
};

/**
 * Stringified snapshot of a step's answers for cheap `===` comparison. Same as we store in DB
*/
export const snapshotStep = (step) => {
  if (!step || !step.question || step.no_user_input) return undefined;

  return JSON.stringify(_.keyBy(getStepAnswer(step).answers, 'question_uid'))
};

/**
 * Revert a step's in-memory answers to the baseline.
 *
 * @return {Boolean} true when the step's answers were mutated (caller should re-render).
 */
export const revertStepToBaseline = (step, baseline) => {
  if (!step || baseline === undefined) return false;

  const groupedAnswers = JSON.parse(baseline);

  restoreAnswers(step.question, groupedAnswers);
  return true;
};

const restoreAnswers = (questions, groupedAnswers) => {
  (questions || []).forEach((question) => {
    if (question.question) {
      restoreAnswers(question.question, groupedAnswers);
    } else {
      setQuestionAnswerFromStore(question, groupedAnswers[question.uid] || []);
    }
  });
};
